import { NumericBox } from '@/agiles/components';
import * as Common from '@/tenant/common';
import { SalesPurchaseFlags } from './Delivery';

export class Order extends Common.StateObject{
  constructor(){
    super('Order')
    this.binders.segment = new Common.ModelBinder(Common.Segment);
    this.binders.counterpart = new Common.ModelBinder(Common.Counterpart);
    this.binders.receiver = new Common.ModelBinder(Common.Counterpart);
    this.binders.warehouse = new Common.ModelBinder(Common.Counterpart);
    this.binders.advanceBalance = new Common.ModelBinder(Common.TransferBalance);
  }

  public orderNo: string = '';
  public get voucherNo() {
    return this.orderNo;
  }
  public closedCanEdit:boolean = true;  // ワークフロー終着点（完了・失注）でも編集許可。
  public salesPurchaseFlag: number = 0;
  public orderFlag: boolean = false;
  public segmentId: number = 0;
  public segment: Common.Segment = null;
  public pic: string = null;
  public refNo: string = '';
  public customerOrderNo: string = '';
  public counterpartId: number = 0;
  public counterpart: Common.Counterpart = null;
  public warehouseId: number = null;
  public warehouse: Common.Counterpart = null;
  public receiverId: number = null;
  public receiver: Common.Counterpart = null;
  public deliveryFlag: number = 0;
  public orderDate: Date = new Date().getCalendarDate();
  public requestDate: Date = new Date().getCalendarDate();
  public currencyCode: string = '';
  public dueDate: Date = null;
  public isSubscription: boolean = false; //サブスクリプション区分            
  public nextSettlementDate: Date = null;   //次回清算日
  //案件
  public projectItemNo : string = null;
  public projectItem : Common.ProjectItem = null;
  // 金額
  public dealAmountFC: number = 0; // 受発注金額
  public amountFC: number = 0;
  public taxAmountFC: number = 0;
  
  // 前受金/前払金
  public advanceAmountFC: number = 0; // 前受金請求金額/前払金支払金額
  public advanceBalanceId: number = 0;
  public advanceBalance: Common.TransferBalance = null; // 残高管理オブジェクト
  public writeoffAmountFC: number = 0; // 消込金額(入金処理用項目)
  public advancePendingBalanceAmountFC:number = 0; //入金可能額・支払可能額


  // 記載事項
  public paymentTerm: string = '';
  public description: string = '';
  public remark: string = '';
  public deliveryInstruction: string = '';

  // 納入先詳細  
  public outputReceiverPostalCode: string = '';
  public outputReceiverAddress1: string = '';
  public outputReceiverAddress2: string = '';
  public outputReceiverAddress3: string = '';
  public outputReceiverName: string = '';
  public outputReceiverPICSection: string = '';
  public outputReceiverPIC: string = '';
  public outputReceiverPICHonorificTitle: string = '';
  public outputReceiverTelNo: string = '';
  public outputReceiverFaxNo: string = '';

  // 予備項目
  public reserveText1: string = '';
  public reserveText2: string = '';
  public reserveText3: string = '';
  public reserveText4: string = '';
  public reserveText5: string = '';
  public reserveText6: string = '';
  public reserveMemo1: string = '';
  public reserveMemo2: string = '';
  public reserveMemo3: string = '';
  public reserveDate1: Date = null;
  public reserveDate2: Date = null;
  public reserveDate3: Date = null;
  public reserveList1: number = null;
  public reserveList2: number = null;
  public reserveList3: number = null;
  public sourceOrderNo: string = null;
  public importNo: string = null;
  public ecFlag: Common.ECFlags = Common.ECFlags.None;
  public ecSettingSeqNo: number = null;

  // 揮発性フィールド
  public hasNoPriceItem: boolean = false;   // 発注処理時、単価0発注有無
  public isCopyEdit: boolean = false; // 複製時にフラグオン
  public designationReportTemplateId: number = null; // 指定帳票

  public copy():any {
    const temp = super.copy() as Order;
    temp.sourceOrderNo = this.orderNo;
    temp.isCopyEdit = true;
    if(this.salesPurchaseFlag == SalesPurchaseFlags.Sales){
      temp.state = OrderStatus.SalesOrderSaving;
      temp.workflowStateId = OrderStatus.SalesOrderSaving;
    }
    else
    {
      temp.state = OrderStatus.PurchaseOrderSaving;
      temp.workflowStateId = OrderStatus.PurchaseOrderSaving;
    }
    temp.orderNo = '';
    temp.importNo = null;
    temp.advanceBalance = null;
    temp.dealAmountFC = 0;
    temp.advanceAmountFC = 0;
    temp.ecFlag = Common.ECFlags.None;
    temp.ecSettingSeqNo = null;
    return temp;
  }

  public onChangeCounterpart(){
    if(this.counterpart != null){
      this.reserveText1 = this.counterpart.reserveText1;
      this.reserveText2 = this.counterpart.reserveText2;
      this.reserveText3 = this.counterpart.reserveText3;
      this.reserveText4 = this.counterpart.reserveText4;
      this.reserveText5 = this.counterpart.reserveText5;
      this.reserveText6 = this.counterpart.reserveText6;
      this.reserveMemo1 = this.counterpart.reserveMemo1;
      this.reserveMemo2 = this.counterpart.reserveMemo2;
      this.reserveMemo3 = this.counterpart.reserveMemo3;
      this.reserveList1 = this.counterpart.reserveList1;
      this.reserveList2 = this.counterpart.reserveList2;
      this.reserveList3 = this.counterpart.reserveList3;
      this.paymentTerm = this.counterpart.paymentTerm;
      this.description = this.counterpart.description;
      this.remark = this.counterpart.remark;
    }
    else{
      this.reserveText1 = '';
      this.reserveText2 = '';
      this.reserveText3 = '';
      this.reserveText4 = '';
      this.reserveText5 = '';
      this.reserveText6 = '';
      this.reserveMemo1 = '';
      this.reserveMemo2 = '';
      this.reserveMemo3 = '';
      this.reserveList1 = null;
      this.reserveList2 = null;
      this.reserveList3 = null;
      this.paymentTerm = '';
      this.description = '';
      this.remark = '';
    }
  }

  public onChangeReceiver(){
    if(this.receiver != null){
      this.outputReceiverPostalCode = this.receiver.postalCode;
      this.outputReceiverAddress1 = this.receiver.address1;
      this.outputReceiverAddress2 = this.receiver.address2;
      this.outputReceiverAddress3 = this.receiver.address3;
      this.outputReceiverName = this.receiver.name;
      this.outputReceiverPICSection = this.receiver.picSection;
      this.outputReceiverPIC = this.receiver.pic;
      this.outputReceiverPICHonorificTitle = this.receiver.honorificTitle;
      this.outputReceiverTelNo = this.receiver.telNo;
      this.outputReceiverFaxNo = this.receiver.faxNo;
    }
    else{
      this.outputReceiverPostalCode = '';
      this.outputReceiverAddress1 = '';
      this.outputReceiverAddress2 = '';
      this.outputReceiverAddress3 = '';
      this.outputReceiverName = '';
      this.outputReceiverPICSection = '';
      this.outputReceiverPIC = '';
      this.outputReceiverPICHonorificTitle = '';
      this.outputReceiverTelNo = '';
      this.outputReceiverFaxNo = '';
    }
  }
  public onChangeWarehouse(){
    if(this.warehouse != null){
      this.outputReceiverPostalCode = this.warehouse.postalCode;
      this.outputReceiverAddress1 = this.warehouse.address1;
      this.outputReceiverAddress2 = this.warehouse.address2;
      this.outputReceiverAddress3 = this.warehouse.address3;
      this.outputReceiverName = this.warehouse.name;
      this.outputReceiverPICSection = this.warehouse.picSection;
      this.outputReceiverPIC = this.warehouse.pic;
      this.outputReceiverPICHonorificTitle = this.warehouse.honorificTitle;
      this.outputReceiverTelNo = this.warehouse.telNo;
      this.outputReceiverFaxNo = this.warehouse.faxNo;
    }
    else{
      this.outputReceiverPostalCode = '';
      this.outputReceiverAddress1 = '';
      this.outputReceiverAddress2 = '';
      this.outputReceiverAddress3 = '';
      this.outputReceiverName = '';
      this.outputReceiverPICSection = '';
      this.outputReceiverPIC = '';
      this.outputReceiverPICHonorificTitle = '';
      this.outputReceiverTelNo = '';
      this.outputReceiverFaxNo = '';
    }
  }  
  public get messageOnEdit():string { 
    switch(this.state){
      case OrderStatus.SalesOrderWaiting: return '「再見積」をクリックして状態を「見積提示待ち」に戻してから編集してください。';      
      case OrderStatus.SalesOrderLost: return '「失注取消」をクリックして状態を「見積提示待ち」に戻してから編集してください。';
      case OrderStatus.SalesOrderItemsOperateWaiting:return '「確定取消」をクリックして状態を「見積提示待ち」に戻してから編集してください。';
      case OrderStatus.SalesOrderItemsOperating:
      case OrderStatus.SalesOrderArrivalWaiting:
      case OrderStatus.SalesOrderInstructionWaiting:
      case OrderStatus.SalesOrderCompleted:return '出荷処理・発注処理が行われているため編集できません。\r\n編集する場合は、先に【関連伝票】で表示される出荷伝票・発注伝票をすべて削除してから、「確定取消」をクリックしてください。';
      case OrderStatus.PurchaseOrderItemsOperateWaiting:return '「確定取消」をクリックして状態を「発注確定待ち」に戻してから編集してください。';
      case OrderStatus.PurchaseOrderItemsOperating:
      case OrderStatus.PurchaseOrderCompleted: return '入荷処理が行われているため編集できません。\r\n編集する場合は、【関連伝票】で表示される入荷伝票をすべて削除してから、「確定取消」をクリックしてください。';
      default: return super.messageOnEdit;
    }
  }
  public get messageOnDelete():string {
    switch(this.state){
      case OrderStatus.SalesOrderWaiting: return '「再見積」をクリックして状態を「見積提示待ち」に戻してから削除してください。';
      case OrderStatus.SalesOrderLost: return '「失注取消」をクリックして状態を「見積提示待ち」に戻してから削除してください。';
      case OrderStatus.SalesOrderItemsOperateWaiting:return '「確定取消」をクリックして状態を「見積提示待ち」に戻してから削除してください。';
      case OrderStatus.SalesOrderItemsOperating:
      case OrderStatus.SalesOrderArrivalWaiting:
      case OrderStatus.SalesOrderInstructionWaiting:        
      case OrderStatus.SalesOrderCompleted:return '出荷処理・発注処理が行われているため削除できません。\r\n削除する場合は、先に【関連伝票】で表示される出荷伝票・発注伝票をすべて削除してから、「確定取消」をクリックしてください。';
      case OrderStatus.PurchaseOrderItemsOperateWaiting:return '「確定取消」をクリックして状態を「発注確定待ち」に戻してから削除してください。';
      case OrderStatus.PurchaseOrderItemsOperating:
      case OrderStatus.PurchaseOrderCompleted:return '入荷処理が行われているため削除できません。\r\n削除する場合は、先に【関連伝票】で表示される入荷伝票をすべて削除してから、「確定取消」をクリックしてください。';
      default: return super.messageOnDelete;
    }
  }
  public get messageOnActionMissing():string{
    if (this.salesPurchaseFlag == SalesPurchaseFlags.Sales) return '出荷処理・発注処理が行われているため、ワークフロー操作は行えません。';
    else return '入荷処理が行われているため、ワークフロー操作は行えません。';
  }
}

export enum OrderStatus
{
    SalesOrder = 1,//受注
    PurchaseOrder = 2,//発注

    SalesOrderSaving = SalesOrder + 16, // 見積提示待ち
    SalesOrderWaiting = SalesOrder + 32, // 受注確定待ち
    SalesOrderLost = SalesOrder + 64, // 失注
    SalesOrderReceiptWaiting = SalesOrder + 128, // 入金処理待ち
    SalesOrderPartialReceiptWaiting = SalesOrder + 256, // 入金処理中
    SalesOrderItemsOperateWaiting = SalesOrder + 512, // 出荷処理待ち
    SalesOrderItemsOperating = SalesOrder + 1024, // 出荷処理中
    SalesOrderArrivalWaiting = SalesOrder + 2048, //入荷待ち
    SalesOrderInstructionWaiting = SalesOrder + 4096,//出荷指示待ち
    SalesOrderCompleted = SalesOrder + 8192, // 完了
    SalesOrderNotCompleted = SalesOrderSaving | SalesOrderWaiting | SalesOrderReceiptWaiting | SalesOrderPartialReceiptWaiting | SalesOrderItemsOperateWaiting | SalesOrderItemsOperating | SalesOrderArrivalWaiting | SalesOrderInstructionWaiting,

    PurchaseOrderSaving = PurchaseOrder + 16, // 発注確定待ち
    PurchaseOrderPaymentWaiting = PurchaseOrder + 32, // 支払処理待ち
    PurchaseOrderPartialPaymentWaiting = PurchaseOrder + 64, // 支払処理中
    PurchaseOrderItemsOperateWaiting = PurchaseOrder + 128, // 入荷処理待ち
    PurchaseOrderItemsOperating = PurchaseOrder + 256, // 入荷処理中
    PurchaseOrderCompleted = PurchaseOrder + 512, // 完了
    PurchaseOrderNotCompleted = PurchaseOrderSaving | PurchaseOrderPaymentWaiting | PurchaseOrderPartialPaymentWaiting | PurchaseOrderItemsOperateWaiting | PurchaseOrderItemsOperating
}

export class SalesOrder extends Order{
  constructor(){
    super()
    this.salesPurchaseFlag = Common.SalesPurchaseFlags.Sales;
    this.workflowCode="salesOrder";
    this.state = OrderStatus.SalesOrderSaving;
    this.workflowStateId = OrderStatus.SalesOrderSaving;
  }
  public get actionTooltip() {
    if (!this.orderNo) return '必須項目(★マーク)を入力して【追加する】をクリックします。';
    else if (this.state == Common.OrderStatus.SalesOrderSaving)　return '明細の登録は、【受注明細タブ】で【明細の追加】をクリックします。出荷、発注へ進む場合は【受注確定】をクリックします。';
    else if (this.state == Common.OrderStatus.SalesOrderWaiting) return '出荷、発注へ進む場合は【受注確定】をクリックします。失注となった場合は【失注処理】をクリックします。';
    else if (this.state == Common.OrderStatus.SalesOrderLost) return '失注を取り消す場合は【失注取消】をクリックします。';
    else if (this.state == Common.OrderStatus.SalesOrderItemsOperateWaiting) return '在庫から出荷する場合は【出荷処理】をクリックします。発注する場合は【発注処理】をクリックします。';        
    else if (this.state == Common.OrderStatus.SalesOrderItemsOperating) return '在庫から出荷する場合は【出荷処理】をクリックします。発注する場合は【発注処理】をクリックします。';            
    else if (this.state == Common.OrderStatus.SalesOrderCompleted) return '';           
    else return '';
  }
  public copy():any {
    const temp = super.copy() as SalesOrder;
    temp.state = OrderStatus.SalesOrderSaving;
    temp.workflowStateId = OrderStatus.SalesOrderSaving;
    return temp;
  }
  public getTargetState(stateId : number, actionFlag : Common.DefaultActionFlags){
    //編集=>失注・出荷処理待ち
    // if (actionFlag == Common.DefaultActionFlags.edit && (stateId == OrderStatus.SalesOrderLost || stateId == OrderStatus.SalesOrderItemsOperateWaiting))
    //   return OrderStatus.SalesOrderSaving;
    //削除=>受注確定待ち・失注・出荷処理待ち
    if (actionFlag == Common.DefaultActionFlags.delete  && (stateId == OrderStatus.SalesOrderWaiting || stateId == OrderStatus.SalesOrderLost || stateId == OrderStatus.SalesOrderItemsOperateWaiting))
      return OrderStatus.SalesOrderSaving;
    //更新=>見積提示待ち・受注確定待ち
    else if (actionFlag == Common.DefaultActionFlags.update && (stateId == OrderStatus.SalesOrderSaving || stateId == OrderStatus.SalesOrderWaiting ))
      return OrderStatus.SalesOrderReceiptWaiting;  
    else
      return 0;
  }  
}

export class OrderQuery extends Common.LoadQuery {
  constructor(salesPurchaseFlag: Common.SalesPurchaseFlags){
    super('OrderQuery', salesPurchaseFlag == Common.SalesPurchaseFlags.Purchase ? PurchaseOrder : SalesOrder);
    this.salesPurchaseFlag = salesPurchaseFlag;
    this.state = salesPurchaseFlag == Common.SalesPurchaseFlags.Purchase ? Common.OrderStatus.PurchaseOrderNotCompleted : Common.OrderStatus.SalesOrderNotCompleted;
    this.sort = 'orderNo';
  }
  
  public get binder(): Common.ModelBinder {
    var binder = super.binder;
    binder.createInstance = ()=>new OrderQuery(this.salesPurchaseFlag);    
    return binder;
  }
  public salesPurchaseFlag: Common.SalesPurchaseFlags = Common.SalesPurchaseFlags.Purchase;
  public orderFlag: boolean = false;
  public segment:  Common.Segment = null;
  public counterpart: Common.Counterpart = null;
  public projectItem: Common.ProjectItem = null;
  public projectItemNo: string = null;  
  public pic: string = "";
  public currencyCode = "";
  public orderNo: string = '';
  public salesOrderNo: string = '';
  public refNo: string = '';
  public custormeOrderNo: string = '';
  public description: string ="";
  public receiverName: string = '';
  public orderDateFrom: Date = null;
  public orderDateTo: Date = null;
  public requestDateFrom: Date = null;
  public requestDateTo: Date = null;
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.OrderStatus = Common.OrderStatus.SalesOrderNotCompleted;
  public holder: string = "";
  public dealAmountFcFrom: number = null;
  public dealAmountFcTo: number = null;
  public nextSettlementDate: Date = null;
  // 取引先区分
  public category1: number = null;
  public category2: number = null;
  public category3: number = null;
  public category4: number = null;
  public category5: number = null;
  public category6: number = null;

  //日付フラグ
  public orderDateFromFlag: Common.dateFlags = Common.dateFlags.default;
  public orderDateToFlag : Common.dateFlags = Common.dateFlags.default;
  public requesDateFromFlag: Common.dateFlags = Common.dateFlags.default;
  public requesDateToFlag : Common.dateFlags = Common.dateFlags.default;  
  public nextSettlementDateFlag : Common.dateFlags = Common.dateFlags.default;    

  // 予備項目
  public reserveText1: string = '';
  public reserveText2: string = '';
  public reserveText3: string = '';
  public reserveText4: string = '';
  public reserveText5: string = '';
  public reserveText6: string = '';
  public reserveMemo1: string = '';
  public reserveMemo2: string = '';
  public reserveMemo3: string = '';
  public reserveDate1From: Date = null;
  public reserveDate1To: Date = null;
  public reserveDate2From: Date = null;
  public reserveDate2To: Date = null;
  public reserveDate3From: Date = null;
  public reserveDate3To: Date = null;
  public reserveList1: number = null;
  public reserveList2: number = null;
  public reserveList3: number = null;
}
export class PurchaseOrderQuery extends OrderQuery {
  constructor(){
    super(SalesPurchaseFlags.Purchase);
  }
}

export class PurchaseOrder extends Order{
  constructor(){
    super()
    this.salesPurchaseFlag = Common.SalesPurchaseFlags.Purchase;
    this.workflowCode="purchaseOrder";
    this.state = OrderStatus.PurchaseOrderSaving;
    this.workflowStateId = OrderStatus.PurchaseOrderSaving;
  }
  public get actionTooltip() {
    if (!this.orderNo) return '必須項目(★マーク)を入力して【追加する】をクリックします。';    
    else if (this.state == Common.OrderStatus.PurchaseOrderSaving)　return '明細の登録は、【発注明細タブ】で【明細の追加】をクリックします。入荷へ進む場合は【発注確定】をクリックします。';
    else if (this.state == Common.OrderStatus.PurchaseOrderPaymentWaiting) return '';
    else if (this.state == Common.OrderStatus.PurchaseOrderPartialPaymentWaiting) return '';
    else if (this.state == Common.OrderStatus.PurchaseOrderItemsOperateWaiting) return '入荷をする場合は【入荷処理】をクリックします。';        
    else if (this.state == Common.OrderStatus.PurchaseOrderItemsOperating) return '入荷をする場合は【入荷処理】をクリックします。';            
    else if (this.state == Common.OrderStatus.PurchaseOrderCompleted) return '';           
    else return '';
  }
  public copy():any {
    if(this.orderFlag) throw new Error("発注処理で作成された発注伝票は複製できません。");
    const temp = super.copy() as PurchaseOrder;
    temp.state = OrderStatus.PurchaseOrderSaving;
    temp.workflowStateId = OrderStatus.PurchaseOrderSaving;
    return temp;
  }
  public getTargetState(stateId : number, actionFlag : Common.DefaultActionFlags){
    //編集=>入荷処理待ち
    // if (actionFlag == Common.DefaultActionFlags.edit && stateId == OrderStatus.PurchaseOrderItemsOperateWaiting) 
    //   return OrderStatus.PurchaseOrderSaving;
    //削除=>入荷処理待ち
    if (actionFlag == Common.DefaultActionFlags.delete && stateId == OrderStatus.PurchaseOrderItemsOperateWaiting)
      return OrderStatus.PurchaseOrderSaving;      
    //更新=>見積提示待ち・受注確定待ち        
    else if (actionFlag == Common.DefaultActionFlags.update && stateId == OrderStatus.PurchaseOrderSaving) 
      return OrderStatus.PurchaseOrderPaymentWaiting;
    else
      return 0;
  }    
}

export class AdvanceReceiptQuery extends Common.Query {
  constructor(){
    super('AdvanceReceiptQuery',new Common.ModelBinder(Common.Payment,false));
  }
  public segment: Common.Segment;
  public pic: string;
  public counterpart: Common.Counterpart;
  public currencyCode: string;
  public receiptDate: Date;
  public bankAccount: Common.BankAccount;
  public exchangeRate: number;
  public commissionAmountFC: number;
  public settlementAmountFC: number;
  public commissionTaxFlag: boolean;
  public workflowId :number = 0;
  public orders: Array<Common.Order>;
}

export class BundleAddOrderItemQuery extends Common.Query {
  constructor(salesPurchaseFlag:number){
      if(salesPurchaseFlag == Common.SalesPurchaseFlags.Sales)
        super('BundleAddOrderItemQuery',new Common.ModelBinder(SalesOrder,false));
      else
        super('BundleAddOrderItemQuery',new Common.ModelBinder(PurchaseOrder,false));
    }
    public orderItems: Array<Common.OrderItem>;
}

export class AdvancePaymentQuery extends Common.Query {
  constructor(){
    super('AdvancePaymentQuery',new Common.ModelBinder(Order,false));
  }
  public segment: Common.Segment;
  public pic: string;
  public counterpart: Common.Counterpart;
  public currencyCode: string;
  public paymentDate: Date;
  public bankAccount: Common.BankAccount;
  public exchangeRate: number;
  public commissionAmountFC: number;
  public settlementAmountFC: number;
  public commissionTaxFlag: boolean;
  public workflowId :number = 0;  
  public orders: Array<Common.Order>;
}

export class AdvanceBalanceQuery extends Common.LoadQuery {
  constructor(counterpartId:number,salesPurchaseFlag:number){
        super('AdvanceBalanceQuery',Order);
        this.counterpartId = counterpartId;
        this.salesPurchaseFlag = salesPurchaseFlag;
    }
    public counterpartId: number = 0;
    public salesPurchaseFlag: number = 0;
} 

export class GetOrderItemQuery extends Common.Query{
  constructor(){
    super('GetOrderItemQuery', new Common.ModelBinder(Common.OrderItem, true));
  }
  public orderNo: string = '';
}

export class OrderImportQuery extends Common.ImportQuery {
  constructor(sheetName:string, salesPurchaseFlag:number){
    super("",null);
    this.className = "OrderImportQuery";
    this.sheetName = sheetName;
    this.salesPurchaseFlag = salesPurchaseFlag;
  }
  public sheetName  :string;
  public salesPurchaseFlag : number;
  public hasLicenseCurrency: boolean = false;
  public hasLicenseImport: boolean = false;
  public hasLicenseExport: boolean = false;
}
export class OrderExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery, salesPurchaseFlag:number){
    super("",loadQuery ); 
    this.className = "OrderExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
    this.salesPurchaseFlag = salesPurchaseFlag;
  }
  public loadQuery : Common.LoadQuery;
  public sheetName  :string;
  public salesPurchaseFlag : number;
  public hasLicenseCurrency: boolean = false;
  public hasLicenseImport: boolean = false;
  public hasLicenseExport: boolean = false;
}
export class OrderShippingInstructionsQuery extends Common.Query {
    constructor(){
        super('OrderShippingInstructionsQuery',new Common.ModelBinder(Common.Delivery,true));
    }
    public parent: Order;
    public orderItems: Array<Common.OrderItem> = new Array(0);
    public workflowId = 0;
    public actionId: number = 0;
    public pic: string = '';
    public refNo: string = '';
    public deliveryDate: Date = new Date().getCalendarDate();
    public deliveryInstruction: string = '';
    public warehouse: Common.Counterpart;
    public orderByStock: Common.StockOrder;
    public adStock: boolean;
    public isBulkOrder: boolean;
    public processingDivision: number;
    public onlyAllocate: boolean;
}

// 定期出荷サイクル、値が間隔月になるように設定。
export enum RegularlySycle 
{
    None =0,
    Monthly = 1,
    Quarter = 3,
    HalfPeriod = 6,
    Yearly = 12,
}
export class RegularlyDeliveryQuery extends Common.Query {
  constructor(){
      super('regularlyDeliveryQuery',new Common.ModelBinder(Common.OrderItem,true));
  }
    public salesOrderItems: Array<Common.SalesOrderItem>;
    public workflowId: number;
    public pic: string;
    public deliveryRefNo: string;
    public regularlyStartMonth: Date;
    public regularlyDate: number;
    public regularlySycle: number;
    public regularlyTimes: number;
    public actionId: number;
}

export class OrderItemCloseQuery extends Common.Query {
  constructor(){
      super('orderItemCloseQuery',new Common.ModelBinder(Common.Order,false));
  }
  public orderItems: Array<Common.SalesOrderItem>;
  public isClose:boolean = true;
}

export class OrderItemSubscriptionUpdateQuery extends Common.Query {
  constructor(orderItems: Common.SalesOrderItem[], subscriptionStartDate: Date, subscriptionEndDate : Date){
      super('OrderItemSubscriptionUpdateQuery',new Common.ModelBinder(Common.Order,false));
      this.subscriptionStartDate = subscriptionStartDate;
      this.subscriptionEndDate = subscriptionEndDate;
      this.orderItems = orderItems;
  }
  public orderItems: Array<Common.SalesOrderItem>;
  public subscriptionStartDate : Date = null;
  public subscriptionEndDate : Date = null;  
}